import { render, staticRenderFns } from "./ModalCalendar.vue?vue&type=template&id=3670c175&scoped=true&"
import script from "./ModalCalendar.vue?vue&type=script&lang=js&"
export * from "./ModalCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ModalCalendar.vue?vue&type=style&index=0&id=3670c175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670c175",
  null
  
)

export default component.exports